import { BehaviorSubject, Subject } from 'rxjs';
let instance;
class LocaleManager {
  #localeSubject = new Subject('ko');

  initialize = (method = () => {}) => {
    this.#localeSubject.subscribe(method);
  };
  setLocale = (locale) => {
    this.#localeSubject.next(locale);
  };
}
export default (() => {
  if (!instance) instance = new LocaleManager();
  return instance;
})();
